export enum ProductSuite {
  ML = 'Management Liability',
  Cyber = 'Cyber',
  Tech = 'Tech E&O',
}
